import { render } from "./ModuleShow.vue?vue&type=template&id=2132d3c7&scoped=true&ts=true"
import script from "./ModuleShow.vue?vue&type=script&lang=ts"
export * from "./ModuleShow.vue?vue&type=script&lang=ts"

import "./ModuleShow.vue?vue&type=style&index=0&id=2132d3c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2132d3c7"]])

export default __exports__